import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AssetPathModule } from '@hdms/shared/util-core';

import { SvgIconComponent } from './svg-icon.component';

@NgModule({
  declarations: [SvgIconComponent],
  imports: [CommonModule, AssetPathModule],
  exports: [SvgIconComponent]
})
export class SvgIconModule {}

export * from './svg-icon.component';
